export const pathConstants = {
  empty: "",
  defaultRoute: "/",
  wildCard: "*",
  login: "/login",
}
